import { ToolType, getTypeIcon as getTypeIconFromEnum, stringToToolType } from './ToolTypes';

// Function to get the appropriate icon for each tool type
// This function accepts both string and enum types for backward compatibility
export const getTypeIcon = (toolType: string | ToolType): string => {
    // If it's already a ToolType enum, use it directly
    if (typeof toolType === 'string' && Object.values(ToolType).includes(toolType as ToolType)) {
        return getTypeIconFromEnum(toolType as ToolType);
    }
    
    // If it's a string, convert it to ToolType enum first
    if (typeof toolType === 'string') {
        const enumType = stringToToolType(toolType);
        return getTypeIconFromEnum(enumType);
    }
    
    // Fallback
    return 'Settings';
};
